export default __webpack_public_path__ + "static/media/lifecycle-compact.5ac7f97e.png";